export default __webpack_public_path__ + "static/media/ftth_300_speed.14a6c0d0.jpg";